import { reactive } from 'vue'

export const appState = reactive({
  isEmailPreviewApp: false,
  selectedPage: '',
  scheduleId: '',
  locationId: '',
  templateId: '',
  templateName: '',
  folderId: '',
  isModalDialog: false,
  cloneTemplate: false,
})
